import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import { Invite } from "@platform/types";
import { JSX } from "react";

import { InvitesTable } from "../../components";

function Invites({
  onInvite,
  data,
  invalidateQueryKey,
}: {
  onInvite: VoidFunction;
  data: Invite[];
  invalidateQueryKey: string[];
}): JSX.Element {
  return (
    <>
      <Box
        mb={5}
        sx={{ width: "100%", justifyContent: "space-between", display: "flex" }}
      >
        <Typography variant="display-medium">Users</Typography>
        <Box>
          <Button
            sx={{
              whiteSpace: "nowrap",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            variant="primary"
            onClick={onInvite}
            startIcon={<AddIcon />}
          >
            Add user
          </Button>
        </Box>
      </Box>
      <Box mb={3}>
        <Typography variant="header-medium">Invites</Typography>
      </Box>
      <InvitesTable data={data} invalidateQueryKey={invalidateQueryKey} />
    </>
  );
}

export default Invites;
